/*
 * Exports
 */
export { default } from './components/DigitalFormats.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-formats/index.js